import { cn } from "@tine/designsystem-utils";
import { type ElementType, forwardRef, type HTMLAttributes } from "react";

type MainColumnProps = HTMLAttributes<HTMLDivElement> & {
   as?: ElementType;
};

const outerCN = cn("flex", "flex-row", "justify-center", "w-full");
const innerCN = cn("flex", "flex-row", "w-full", "max-w-[--main-column-max-width]", "px-3 sm:px-4 md:px-12", "shrink-0");

const MainColumn = forwardRef<HTMLElement, MainColumnProps>(
   ({ children, className = "", as: Component = "div", ...rest }, ref) => (
      <Component ref={ref} className={cn([outerCN, className])} {...rest}>
         <div className={innerCN}>{children}</div>
      </Component>
   )
);

export default MainColumn;
